import { render, staticRenderFns } from "./scoreboard.vue?vue&type=template&id=68713c44&"
import script from "./scoreboard.js?vue&type=script&lang=js&"
export * from "./scoreboard.js?vue&type=script&lang=js&"
import style0 from "./scoreboard.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports